import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CampaignDetails = lazy(() =>
  import("@campaigns/CampaignDetails").then((module) => ({ default: module.CampaignDetails }))
);

export const campaignDetailsNRO: NavigationRoutingObject = {
  Component: CampaignDetails,
  componentFeatureFlippers: ["campaigns_nro_component", "campaign_details_nro_component"],
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("campaign-details-nro-heading", "Campaigns"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "campaigns-sidebar-pill-menu-option-description",
      "Manage existing campaigns or create a new one. Recommended for single messages."
    ),
  icon: "new-nav-system-campaigns",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/campaigns/:appGroupId",
};
